import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=299a37de&scoped=true"
import script from "./ProductOffers.vue?vue&type=script&lang=js"
export * from "./ProductOffers.vue?vue&type=script&lang=js"
import style0 from "./ProductOffers.vue?vue&type=style&index=0&id=299a37de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a37de",
  null
  
)

export default component.exports